module.exports = {
    values: {
        BORDER_RADIUS: 8,
        BUTTON_BORDER_WIDTH: 2,
        VIEW_PORT: {
            MOBILE: "600px",
            TABLET: "768px",
            LAPTOP: "1100px",
            DESKTOP: "1200px",
        },
        DEFAULT_TRANSITION_DURATION: "0.3s",
        RIPPLE_TRANSITION_DURATION: "1000ms",
    },
    deprecatedColors: {
        DEFAULT_COLOR: "#7f8a4b",
        HIGHLIGHT_COLOR: "#f2f3ed",
        CART_ITEM: {
            SEPARATOR: "#e5e7eb",
        },
        SUMMARY: {
            DIVIDER: "#d8dcc6",
        },
    },
    colors: {
        WHITE: "#ffffff",
        BLACK: "#000000",
        RIPPLE: "#ffffff",
        BRAND: {
            PRIMARY: {
                1000: "#00E940",
                900: "#19EB53",
                800: "#33ED66",
                700: "#4DF079",
                600: "#66F28C",
                500: "#80F49F",
                400: "#99F6B3",
                300: "#B3F8C6",
                200: "#CCFBD9",
                100: "#E5FDEC",
            },
            SECONDARY: {
                1000: "#171717",
                900: "#1f2937",
                800: "#374151",
                700: "#4b5563",
                600: "#6b7280",
                500: "#9ca3af",
                400: "#d1d5db",
                300: "#e5e7eb",
                200: "#f3f4f6",
                100: "#f9fafb",
            },
        },
        LAYOUT: {
            HIGHLIGHT: {
                1000: "#01ffc2",
                900: "#1affc8",
                800: "#34ffce",
                700: "#4dffd4",
                600: "#67ffda",
                500: "#80ffe0",
                400: "#99ffe7",
                300: "#b3ffed",
                200: "#ccfff3",
                100: "#e6fff9",
            },
            GRAY: {
                1000: "#111827",
                900: "#1f2937",
                800: "#374151",
                700: "#4b5563",
                600: "#6b7280",
                500: "#9ca3af",
                400: "#d1d5db",
                300: "#e5e7eb",
                200: "#f3f4f6",
                100: "#f9fafb",
            },
        },
        SEMANTIC: {
            DANGER: {
                1000: "#ff0101",
                900: "#ff1a1a",
                800: "#ff3434",
                700: "#ff4d4d",
                600: "#ff6767",
                500: "#ff8080",
                400: "#ff9999",
                300: "#ffb3b3",
                200: "#ffcccc",
                100: "#ffe6e6",
            },
            SUCCESS: {
                1000: "#00ea17",
                900: "#19ec2e",
                800: "#33ee45",
                700: "#4df05d",
                600: "#66f274",
                500: "#80f58b",
                400: "#99f7a2",
                300: "#b3f9b9",
                200: "#ccfbd1",
                100: "#e5fde8",
            },
            WARNING: {
                1000: "#ffb240",
                900: "#ffbb53",
                800: "#ffc266",
                700: "#ffca79",
                600: "#ffd18c",
                500: "#ffd99f",
                400: "#ffe1b3",
                300: "#ffe8c6",
                200: "#fff0d9",
                100: "#fff7ec",
            },
        },
        GRADIENT: {
            LEFT: `linear-gradient(
                90deg,
                #19c981 -29.17%,
                #39e486 46.74%,
                #00ff46 107.02%
            )`,
            RIGHT: `linear-gradient(
                90deg,
                #00ff46 -29.17%,
                #39e486 18.36%,
                #19c981 107.02%
            )`,
        },
    },
    text: {
        HEADLINE: {
            FONT: "Kiwari, sans-serif",
            WEIGHT: 700,
        },
        REGULAR: {
            FONT: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            WEIGHT: 400,
        },
        BOLD: {
            FONT: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            WEIGHT: 700,
        },
        MEDIUM: {
            FONT: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            WEIGHT: 400,
        },
        TAGLINE: {
            FONT: "Kiwari, sans-serif",
            WEIGHT: 700,
            TRANSFORM: "uppercase",
        },
    },
};
